import { Component, ElementRef, OnChanges, OnInit, SimpleChanges, inject, input, output } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { FocusTrapper, FocusTrapperFactory } from '../../components/focus/focus-trapper-factory';
import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-filter-window',
  templateUrl: 'filter-window.component.html',
  styleUrls: ['filter-window.component.scss'],
  imports: [
    ButtonComponent,
    TranslatePipe,
    IconComponent
  ]
})
export class FilterWindowComponent implements OnInit, OnChanges {
  private readonly elementRef = inject(ElementRef);
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly focusTrapperFactory = inject(FocusTrapperFactory);

  readonly filtersOpened = input<boolean>(undefined);
  readonly closeEvent = output<void>({ alias: 'close' });

  breakpointChanges$: Observable<BreakpointState>;
  private focusTrapper: FocusTrapper;

  constructor() {
    this.focusTrapper = this.focusTrapperFactory.create(this.elementRef.nativeElement,
      { autoFocus: true });
  }

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filtersOpened !== undefined) {
      if (changes.filtersOpened.currentValue === true) {
        this.focusTrapper.savePreviouslyFocusedElement();
        this.focusTrapper.autoFocusFirstTabbableElement();
      } else {
        this.focusTrapper.returnFocusAfterClose();
        this.focusTrapper.destroy();
      }
    }
  }

  close(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.closeEvent.emit();
  }
}
